export const G_SERVER_URL = 'https://us-central1-beyouid200.cloudfunctions.net/getUserShareData?authCode=';
export const G_SERVER_URL_IMPRESSIONS = 'https://us-central1-beyouid200.cloudfunctions.net/addImpressions?authCode=';
export const G_SERVER_URL_FLAGPOST = 'https://us-central1-beyouid200.cloudfunctions.net/flagginPost?authCode=';
